export const NotificationsLabels = {
  notifications: "Notifications",
  markAsRead: "Mark as Read",
  approve: "Approve?",
  review: "Review?",
  clear: "Clear",
  clearAll: "Clear All",
  clearSection: "Clear Section",
  upload: "Upload",
};

export enum NotificationModules {
  UPCOMING_NEGOTIATIONS = "volume allocation",
  BUSINESS_COST = "business cost",
  COMPLIANCE_MONITORING = "compliance monitoring",
  NIA_OPPORTUNITY = "nia_opportunity",
  REPORTS = "reports",
  REVIEW = "review",
  PENDING_ACTION = "pending action",
}

export enum NotificationTypes {
  APPROVAL = "approval",
  INFO = "info",
  REVIEW = "review",
}

export interface INotificationResponse {
  id: number;
  module: NotificationModules;
  type: NotificationTypes;
  message: string;
  requestedOn: string;
  isMarkAsRead?: boolean;
  isInfo: Boolean;
  isReminder: boolean;
  dateTime: Date;
}

export interface IMarkAsReadResponse {
  notifications: number[] | string[] | [];
  user_email: string;
  isInfo: boolean;
  section: string;
}

export const legendsList = [
  {
    key: NotificationModules.PENDING_ACTION,
    value: "Pending Action",
    isReminder: true,
  },
  {
    key: NotificationModules.UPCOMING_NEGOTIATIONS,
    value: "Negotiations & Allocations",
    isReminder: false,
  },
  {
    key: NotificationModules.BUSINESS_COST,
    value: "Board Cost",
    isReminder: false,
  },
  {
    key: NotificationModules.COMPLIANCE_MONITORING,
    value: "Compliance Monitoring",
    isReminder: false,
  },
  {
    key: NotificationModules.NIA_OPPORTUNITY,
    value: "NIA Opportunity",
    isReminder: false,
  },
  {
    key: NotificationModules.REPORTS,
    value: "Reports",
    isReminder: false,
  },
  {
    key: NotificationModules.REVIEW,
    value: "Review Reminder",
    isReminder: false,
  },
];

export const InfoNotification = [
  "compliance warnings",
  "negotiations",
  "performance alerts",
  "upload requirements",
];
